import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { store } from "./store";
import { Provider } from "react-redux";
import TagManager from "react-gtm-module";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from "react-google-recaptcha-v3";

const tagManagerArgs = {
  gtmId: "GTM-N2KRRPW",
  rel: "preload",
};
TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <GoogleReCaptchaProvider
    render="explicit"
    reCaptchaKey="6Lep5MojAAAAANvAefeTDbdAPwEwDEZTatE22gkz"
  >
    <Provider store={store}>
      <App />
    </Provider>
  </GoogleReCaptchaProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
